class Session {
  destroy() {}

  get user() {
    return this._user;
  }

  set user(value) {
    return (this._user = value);
  }

  get token() {
    return this._token;
  }

  set token(value) {
    return (this._token = value);
  }
}
export default new Session();
